// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.collapse-group-items[data-v-73599eff] {\n  overflow: hidden;\n  -webkit-transition: max-height .3s ease-in-out;\n  transition: max-height .3s ease-in-out;\n}\n.slide-enter-active[data-v-73599eff], .slide-leave-active[data-v-73599eff] {\n  overflow: hidden;\n}\n.slide-leave-to[data-v-73599eff] {\n  max-height: 0px !important;\n}\n", ""]);
// Exports
module.exports = exports;
